import { Component, ElementRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ManualEntryReason, PatientTherapy, ResponseStatus, SearchEventType, SearchPage, ValidationType } from '../shared/clinical.enum';
import { IDetect } from 'src/app/shared/directives/NgxBarCodePutDirective';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, take } from 'rxjs';
import { UserSessionService } from '../../users/shared/user-session.service';
import { ClinicalService } from '../shared/clinical.service';
import { DeviceCatalog, DisassociateRequest, IPatientDeviceAssociation, PatientRecord, SearchRequest } from 'src/app/shared/models/search-request';
import { LoggingService } from 'src/app/shared/services/logging.service';
import { HSPARole } from 'src/app/shared/models/hspa-role.enum';
import { ICreateDevice } from 'src/app/shared/models/IDevice';
import { HttpErrorResponse } from '@angular/common/http';
import { ClinicialUtility } from '../shared/clinical.util';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-patient-detail',
  templateUrl: './patient-detail.component.html',
  styleUrls: ['./patient-detail.component.css']
})
export class PatientDetailComponent implements OnInit, OnDestroy {

  @ViewChild('clinicalcontent') validationModel: TemplateRef<ElementRef>;
  @ViewChild('manualEntryContent') manualEntryModel: TemplateRef<ElementRef>;
  @ViewChild('disassociateContent') disassociateModal: TemplateRef<ElementRef>;
  @ViewChild('changeKeepAssociationContent') changeAssociationModel: TemplateRef<ElementRef>;
  @ViewChild('patientTherapyContent') patientTherapyModal: TemplateRef<ElementRef>;
  @ViewChild('deviceCreationModal') deviceCreationModal: TemplateRef<ElementRef>;

  @Input() modalBodyMessage: string;
  @ViewChild(ToastContainerDirective, { static: true })
  toastContainer: ToastContainerDirective;
  
  resourceKeyValue: any = null;
  modalRef: NgbModalRef;
  searchPatientDeviceValue: string = '';
  selectedManualEntryReason: string = '';
  isCommentsBoxEnabled: boolean = false;
  otherComments: string = '';
  manualEntryForm: FormGroup;
  patientTherapyForm: FormGroup;
  searchType: string = '';
  isLoading: boolean = false;
  isResetButtonEnabled: boolean = false;
  manualEntryReasonList = [];
  clinicalServiceSubscription!: Subscription;
  isFacilityConfigured: boolean;
  lblNotAuthorizedInstruction3: string = '';
  lblNotAuthorizedInstruction4: string = '';
  isManualOkButtonDisabled: boolean = true;
  patientDeviceData: SearchRequest;
  clinicalSearchPlaceholder: string;
  detailPageSearchHeader: string = '';
  clinicalAssociationSubscription!: Subscription;
  patientDataSubscription!: Subscription;
  patientDeviceAssociationRequest: IPatientDeviceAssociation[] = [];
  modalBodyMessage1: string = '';
  patientDeviceDisassociationSubscription!: Subscription;
  searchPageEnum: typeof SearchPage = SearchPage;
  // PARAMETERS TO STORE THE DELETEION DATA TEMPORARAY
  modalMessage: string = '';
  deletedId: number = null;
  searchPage: string = '';
  disassociateMode: string = '';
  disassociateModalTitle: string = '';
  isClinicianUser: boolean;
  searchAPIResponse: SearchRequest;
  patientTherapy: typeof PatientTherapy = PatientTherapy;
  deviceResponseList: DeviceCatalog[] = [];
  modelsRegex = [];
  resource: string = "";

  ngOnInit(): void {
    this.isLoading = true;
    this.userSessionService.getUserSession().pipe(
      take(1))
      .subscribe((session) => {
        if (session) {
          this.isLoading = false;
          this.isFacilityConfigured = session.facilityId ? true : false;
        }
      })

    this.resourcesService.bsObject.subscribe(result => {
      result && (this.resourceKeyValue = result);
      this.resource = this.resourceKeyValue.resourceKeyClinician;
      this.setControlValues();
      this.setmanualEntryResonList();
    });

    this.patientDataSubscription = this.clinicalService.getPatientDeviceDetailData().subscribe((response) => {
      this.patientDeviceData = response.response;
      this.modelsRegex = this.patientDeviceData.deviceModelRegex.map(x => x);
      this.updateLocation(this.patientDeviceData.patientRecord);
      if (localStorage.getItem("SearchPage") == SearchPage.Device) {
        this.patientDeviceAssociationRequest.push(this.createAssociationRequest(this.patientDeviceData.deviceCatalog));
      }
    });

    this.updateDetailPageHeaderAndPlaceholder();
    if (Number(localStorage.getItem("userRole")) == HSPARole.ClinicianUser) {
      this.isClinicianUser = true;
    }
  }

  constructor(private modalService: NgbModal,
    private userSessionService: UserSessionService,
    private fb: FormBuilder,
    private clinicalService: ClinicalService,
    private resourcesService: ResourcesService,
    private loggerService: LoggingService,
    public toastrService: ToastrService
  ) {
    this.toastrService.overlayContainer = this.toastContainer;
    this.manualEntryForm = this.fb.group({
      'manualEntryReason': ['', Validators.required],
      'othercomments': [''],
    });

    this.patientTherapyForm = this.fb.group({
      'patientTherapyName': ['', Validators.required],
    });
  }

  // Static list of manual entry reasons 
  setmanualEntryResonList() {
    this.manualEntryReasonList = [
      {
        label: this.resourceKeyValue.clinicianBarcodeDamaged,
        value: '1'
      },
      {
        label: this.resourceKeyValue.clinicianBarcodeNotAvailable,
        value: '2'
      },
      {
        label: this.resourceKeyValue.clinicianBarcodeWouldNotScan,
        value: '3'
      },
      {
        label: this.resourceKeyValue.clinicianOther,
        value: '4'
      },
    ];
  }

  get manualFormData(): any { return this.manualEntryForm.controls; }
  get patientTherapyFormData(): any { return this.patientTherapyForm.controls; }

  submitManualEntryForm() {
    this.otherComments = this.manualFormData.othercomments.value;
    if (this.manualFormData.manualEntryReason.value == ManualEntryReason.Other &&
      (this.otherComments == "" || this.otherComments == null)) {
      return false;
    }
    else {
      this.isLoading = true;
      if (this.checkIsDeviceAlreadyExist(this.searchPatientDeviceValue)) {
        this.loggerService.activityLog(this.searchPatientDeviceValue + " device already associated.");
        this.closeManualModal();
        this.showDeviceAlreadyAssociatedModal();
        this.isLoading = false;
      }
      else {
        this.searchPatientOrDeviceInfo(this.createSearchRequest());
        this.closeManualModal();
      }
    }
  }

  resetSearchText() {
    this.searchPatientDeviceValue = '';
    this.isResetButtonEnabled = false;
  }

  changeManualReason(selectedEntry: any) {
    if (selectedEntry.value != ManualEntryReason.Other) {
      this.otherComments = '';
      this.isManualOkButtonDisabled = false;
    }
    this.isCommentsBoxEnabled = selectedEntry.value == ManualEntryReason.Other;
    this.selectedManualEntryReason = selectedEntry.label;
    this.isManualOkButtonDisabled = selectedEntry.value == ManualEntryReason.Other && this.otherComments == '';
  }

  // Scanner event on textbox input
  onDetected(event: IDetect) {
    if (event.type == SearchEventType.Scanner) {
      this.searchType = SearchEventType.Scanner;
      // call to search API
      this.isLoading = true;
      if (this.checkIsDeviceAlreadyExist(this.searchPatientDeviceValue)) {
        this.loggerService.activityLog(this.searchPatientDeviceValue + " device already associated.");
        this.showDeviceAlreadyAssociatedModal();
      }
      else {
        this.searchPatientOrDeviceInfo(this.createSearchRequest());
      }
    }
    else if (event.type == SearchEventType.Keyboard) {
      this.toggleResetButton(event.value?.toString());
      if (event.event?.keyCode == 13) {
        this.searchType = SearchEventType.Manual;
        this.manualEntryForm.reset();
        this.isCommentsBoxEnabled = false;
        this.openModal(this.manualEntryModel);
      }
    }
  }

  onDelete(event: IDetect) {
    this.toggleResetButton(event.value?.toString());
  }

  toggleResetButton(value: string) {
    this.isResetButtonEnabled = value == '' ? false : true;
  }

  onKeypressEvent(event: any) {
    if (event.keyCode == 13 && event.target.value.trim() == '') {
      this.modalBodyMessage = this.resourceKeyValue.clinicianModalBodyMessage;
      this.openModal(this.validationModel);
    }
  }

  onCommentsKeyup(value: any) {
    this.isManualOkButtonDisabled = value == '';
  }

  // handle search icon click
  searchPatientDevice() {
    let searchedValue = this.searchPatientDeviceValue.trim();
    if (searchedValue == undefined || searchedValue == "") {
      this.modalBodyMessage = this.resourceKeyValue.clinicianModalBodyMessage;
      this.openModal(this.validationModel);
    }
    else {
      this.manualEntryForm.reset();
      this.openModal(this.manualEntryModel);
    }
  }

  closeManualModal(): void {
    this.closeModal();
    this.resetClinicianData();
  }

  resetClinicianData() {
    this.searchPatientDeviceValue = '';
    this.otherComments = '';
    this.selectedManualEntryReason = '';
    this.toggleResetButton(this.searchPatientDeviceValue);
    this.modalBodyMessage = '';
    this.modalBodyMessage1 = '';
    this.isManualOkButtonDisabled = true;
  }

  openModal(model: TemplateRef<ElementRef>) {
    this.modalRef = this.modalService.open(model, { backdrop: 'static', keyboard: false });
  }

  createSearchRequest(): SearchRequest {
    const searchPatientDeviceValueList = ClinicialUtility.createPatientDeviceSearch(this.searchPatientDeviceValue.trim(), this.patientDeviceData.prefixSuffix, this.modelsRegex);
    this.searchPatientDeviceValue = searchPatientDeviceValueList[0];
    let searchRequest = {
      searchText: this.searchPatientDeviceValue.trim(),
      searchType: this.searchType,
      manualReason: this.selectedManualEntryReason,
      otherComments: this.otherComments,
      facilityId: Number(localStorage.getItem('facilityId')),
      searchPage: localStorage.getItem("SearchPage"),
      searchDelimeterValues: searchPatientDeviceValueList
    };
    return searchRequest;
  }

  searchPatientOrDeviceInfo(searchRequest: SearchRequest): any {

    this.clinicalServiceSubscription = this.clinicalService.searchPatientOrDeviceId(searchRequest).subscribe(response => {
      if (response.status == ResponseStatus.Error) {
        this.handleSearchErrorResponse(response, searchRequest.searchDelimeterValues.join(', '));
      }
      else if (response.status == ResponseStatus.Success) {
        if (response.validationType == ValidationType.ValidDevice) {
          this.searchAPIResponse = response;
          this.manageDeviceValidations(response);
        }
        else {
          // Patient workflow     
          this.patientDeviceData.patientRecord = response.patientRecord;
          this.updateLocation(this.patientDeviceData.patientRecord);
          if (response.patientRecord != null) {
            // if patient is not associated to any devices yet
            if (response.deviceCatalog == null) {
              // create patient-device association for single or multiple devices  
              this.deviceResponseList = this.patientDeviceData.deviceCatalog;
              this.updatePatientId();
              this.addPatientDeviceAssociation(this.patientDeviceAssociationRequest);
            }
            else {
              // if patient has associated devices
              this.deviceResponseList = response.deviceCatalog;
              let alreadyAssociatedDeviceTypes: string = '';
              let onlyOneDeviceTypes: string = '';

              this.patientDeviceData.deviceCatalog.forEach((device) => {
                let deviceObj = response.deviceCatalog.find(x => x.deviceTypeName == device.deviceTypeName);
                if (deviceObj != null) {
                  // if patient association is for same device that is already associated with patient
                  if (deviceObj.id == device.id && deviceObj.associationId > 0) {
                    // add the device type in comma separated string for more than one devices
                    alreadyAssociatedDeviceTypes = alreadyAssociatedDeviceTypes == '' ? device.deviceTypeName : alreadyAssociatedDeviceTypes + ', ' + device.deviceTypeName;
                    // remove this device from AssociationRequest
                    this.updatePatientDeviceAssociationRequest(device.id)
                  }
                  // if patient association is for same device type that is already associated with patient  
                  // only one device type per patient
                  else if (deviceObj.id != device.id) {
                    // add the device type in comma separated string for more than one devices
                    onlyOneDeviceTypes = onlyOneDeviceTypes == '' ? device.deviceTypeName : onlyOneDeviceTypes + ', ' + device.deviceTypeName;
                    // remove this device from AssociationRequest
                    this.updatePatientDeviceAssociationRequest(device.id)
                  }
                }
                else {
                  this.deviceResponseList.push(device);
                }
              });

              if (this.patientDeviceAssociationRequest.length > 0) {
                // create patient-device association for newly added devices 
                // reload existing asssociated devices if any and newly added devices            
                this.updatePatientId();
                this.addPatientDeviceAssociation(this.patientDeviceAssociationRequest);
                this.patientDeviceData.deviceCatalog = this.deviceResponseList;
              }

              // Showing validation msg for already associated devices/only one device type per patient  	
              if (alreadyAssociatedDeviceTypes != "" || onlyOneDeviceTypes != "") {
                if (this.patientDeviceAssociationRequest.length == 0) {
                  this.isLoading = false;
                }
                this.messageBodyForAssociatedDeviceType(alreadyAssociatedDeviceTypes, onlyOneDeviceTypes);
                this.patientDeviceData.deviceCatalog = this.deviceResponseList;
                this.openModal(this.validationModel);
              }
            }
          }
        }
      }
    },
      (error) => {
        this.isLoading = false;
      });
  }

  updatePatientDeviceAssociationRequest(deviceId: number) {
    let associationIndex = this.patientDeviceAssociationRequest.findIndex(x => x.deviceRecordId == deviceId);
    if (associationIndex != -1) {
      this.patientDeviceAssociationRequest.splice(associationIndex, 1);
    }
  }

  messageBodyForAssociatedDeviceType(alreadyAssociatedDeviceTypes: string, onlyOneDeviceTypes: string) {
    let associatedDeviceTypesMessageBody: string = '';
    let onlyOneDeviceTypesMessageBody: string = '';

    if (alreadyAssociatedDeviceTypes != "") {
      associatedDeviceTypesMessageBody = this.resourceKeyValue.deviceTypeAssociated.replace('{deviceTypeName}', alreadyAssociatedDeviceTypes);
    }
    if (onlyOneDeviceTypes != "") {
      onlyOneDeviceTypesMessageBody = this.resourceKeyValue.onlyOneDeviceTypeAssociated.replace('{deviceTypeName}', onlyOneDeviceTypes);
    }
    this.modalBodyMessage = associatedDeviceTypesMessageBody;
    this.modalBodyMessage1 = onlyOneDeviceTypesMessageBody;
  }

  manageDeviceValidations(response: SearchRequest) {
    if (this.patientDeviceData.deviceCatalog == null) {
      this.manageChangeAndNewTherapyWorkflow(response)
    }
    else {
      let deviceTypeName = response.deviceCatalog[0].deviceTypeName;
      // To validate only one device type associated with patient 
      if (this.isDeviceTypeExists(deviceTypeName)) {
        this.isLoading = false;
        this.loggerService.activityLog("DeviceId: " + response.deviceCatalog[0].deviceIdentifier + " , Only one " + deviceTypeName + " can be associated to the patient.");
        let errorMessage = this.resourceKeyValue.onlyOneDeviceTypeAssociated;
        this.modalBodyMessage = errorMessage.replace('{deviceTypeName}', deviceTypeName);
        this.openModal(this.validationModel);
      }
      else {
        this.manageChangeAndNewTherapyWorkflow(response)
      }
    }
  }

  manageChangeAndNewTherapyWorkflow(response: SearchRequest) {
    if (response.activeDeviceAssociation != null) {
      this.isLoading = false;
      this.openChangeAssociationModal(response);
    }
    else if (this.isArcticSunDeviceType(response)) {
      this.isLoading = false;
      this.patientTherapyForm.reset();
      this.openModal(this.patientTherapyModal);
    }
    else {
      this.updateDeviceTable(response);
    }
  }

  updateDeviceTable(response: SearchRequest) {
    if (this.patientDeviceData.deviceCatalog == null) {
      // push searched device data to association request object for local storage
      this.patientDeviceAssociationRequest.push(this.createAssociationRequest(response.deviceCatalog));
      // If patient detail page then create association and update device grid
      if (this.patientDeviceData.patientRecord != null) {
        this.addPatientDeviceAssociation(this.patientDeviceAssociationRequest);
      }
      else {
        this.isLoading = false;
      }
      if (localStorage.getItem("SearchPage") == SearchPage.Device) {
        this.patientDeviceData.deviceCatalog = response.deviceCatalog;
      }
    }
    else {
      // push searched device data to association request object for local storage
      // Remove the previous device info(already asscoiated) and then add searched device
      if (localStorage.getItem("SearchPage") == SearchPage.Patient) {
        this.patientDeviceAssociationRequest.pop();
        this.patientDeviceAssociationRequest.push(this.createAssociationRequest(response.deviceCatalog));
      }
      else {
        this.patientDeviceAssociationRequest.push(this.createAssociationRequest(response.deviceCatalog));
      }
      if (this.patientDeviceData.patientRecord != null) {
        this.addPatientDeviceAssociation(this.patientDeviceAssociationRequest);
      }
      else {
        this.isLoading = false;
      }
      if (localStorage.getItem("SearchPage") == SearchPage.Device) {
        this.patientDeviceData.deviceCatalog.push(response.deviceCatalog[0]);
      }
    }
  }

  isArcticSunDeviceType(response: SearchRequest) {
    return response.isArcticSunDevice != null && response.isArcticSunDevice;
  }

  submitPatientTherapyForm() {
    this.isLoading = true;
    let therapyValue = this.patientTherapyFormData.patientTherapyName.value;
    this.searchAPIResponse.deviceCatalog[0].isNewPatient = therapyValue == PatientTherapy.NewTherapySession;
    this.closeModal();
    this.updateDeviceTable(this.searchAPIResponse);
  }

  setControlValues(): void {
    this.lblNotAuthorizedInstruction3 = this.resourceKeyValue.lblNotAuthorizedInstruction3;
    this.lblNotAuthorizedInstruction4 = this.resourceKeyValue.lblNotAuthorizedInstruction4;
  }

  checkIsDeviceAlreadyExist(deviceId: string): boolean {
    //this.logDeviceValidationMessage();
    if (this.patientDeviceData.deviceCatalog != null) {
      let data = this.patientDeviceData.deviceCatalog.findIndex(x => x.deviceIdentifier.trim() == deviceId.trim());
      return data == -1 ? false : true;
    }
    return false;
  }

  updateSearchBoxPlaceholder() {
    localStorage.setItem("SearchPage", SearchPage.Patient);
    this.clinicalSearchPlaceholder = this.resourceKeyValue.patientDetailSearchPlaceHolder;
    this.detailPageSearchHeader = this.resourceKeyValue.patientPageSearchHeader;
  }

  isDeviceTypeExists(deviceTypeName: string) {
    //this.logDeviceValidationMessage();
    let data = this.patientDeviceData.deviceCatalog.findIndex(x => x.deviceTypeName == deviceTypeName);
    return data == -1 ? false : true;
  }

  logDeviceValidationMessage() {
    let logMessage = "SerachType: " + this.searchType + ", DeviceId: " + this.searchPatientDeviceValue + " , Manual Reason: " + this.selectedManualEntryReason + " , Other Comments: " + this.otherComments;;
    this.loggerService.activityLog(logMessage);
  }

  updateLocation(patientRecord: PatientRecord) {

    if (patientRecord != null) {
      if (patientRecord.bedName == "" && patientRecord.roomName == "" && patientRecord.unit == "") {
        patientRecord.location = "";
      }
      else if (patientRecord.bedName != "" && patientRecord.roomName != "" && patientRecord.unit != "") {
        patientRecord.location = patientRecord.unit + "-" + patientRecord.roomName + "-" + patientRecord.bedName;
      }
      else if (patientRecord.unit != "" && patientRecord.roomName == "" && patientRecord.bedName == "") {
        patientRecord.location = patientRecord.unit;
      }
      else if (patientRecord.unit != "" && patientRecord.roomName != "" && patientRecord.bedName == "") {
        patientRecord.location = patientRecord.unit + "-" + patientRecord.roomName;
      }
      else if (patientRecord.unit == "" && patientRecord.roomName != "" && patientRecord.bedName != "") {
        patientRecord.location = patientRecord.roomName + "-" + patientRecord.bedName;
      }
      else if (patientRecord.unit == "" && patientRecord.roomName == "" && patientRecord.bedName != "") {
        patientRecord.location = patientRecord.bedName;
      }
      else if (patientRecord.unit != "" && patientRecord.roomName == "" && patientRecord.bedName != "") {
        patientRecord.location = patientRecord.unit + "-" + patientRecord.bedName;
      }
    }
  }

  createAssociationRequest(device: DeviceCatalog[]): IPatientDeviceAssociation {
    let data = {
      patientRecordId: this.patientDeviceData.patientRecord == null ? 0 : this.patientDeviceData.patientRecord.id,
      deviceRecordId: device[0].id,
      facilityRecordId: device[0].facilityRecordId,
      deviceTypeRecordId: device[0].deviceTypeRecordId,
      associationId: device[0].associationId,
      deviceIdentifier: device[0].deviceIdentifier,
      patientId: localStorage.getItem("SearchPage") == SearchPage.Patient ? this.patientDeviceData.patientRecord.patientId : "", // for device page set Id after patient scanned
      isNewPatient: device[0].isNewPatient, // for arctic sun device
      oldPatientId: device[0].oldPatientId, // for arctic sun device
      deviceAtlasKey: device[0].deviceAtlasKey,
      deviceTypeCode: device[0].deviceTypeCode,
      oldPatientRecordId: device[0].oldPatientRecordId
    };
    return data;
  }

  addPatientDeviceAssociation(request: IPatientDeviceAssociation[]) {
    this.clinicalAssociationSubscription = this.clinicalService.addPatientDeviceAssociation(request).subscribe(response => {
      // TODO Show error notification if association request failed       
      // Update association Id in device grid for disassociattion workflow
      this.isLoading = false;
      if (localStorage.getItem("SearchPage") == SearchPage.Patient) {
        if (this.patientDeviceData.deviceCatalog == null) {
          this.patientDeviceData.deviceCatalog = this.searchAPIResponse.deviceCatalog;
        }
        else {
          this.patientDeviceData.deviceCatalog.push(this.searchAPIResponse.deviceCatalog[0]);
        }
        this.searchAPIResponse.deviceCatalog = [];
      }
      else {
        this.updateSearchBoxPlaceholder();
      }
      this.updateAssociationIdInDeviceCatalog(response);
      this.showSuccessNotification(this.resourceKeyValue.clinicianSuccessMessageOnCreate);
    },
      (error) => {
        this.isLoading = false;
        this.showErrorNotification(this.resourceKeyValue.clinicianFailedMessageOnCreate);
      });
  }

  handleSearchErrorResponse(response: SearchRequest, searchText: string) {
    let errorMessage: string = "";
    this.isLoading = false;
    this.searchAPIResponse = response;
    this.searchAPIResponse.searchText = searchText;
    // Device regex matched but device does not exists
    if (response.validationType == ValidationType.DeviceRegexMatchedButInvalidDevice) {
      this.openCreateDeviceModal(this.resourceKeyValue.deviceCreationConfirmation);
    }
    else if (response.validationType == ValidationType.RegexMatchDeviceInDifferentFacility) {
      this.openCreateDeviceModal(this.resourceKeyValue.differentFacilityCreateDevice);
    }
    // Invalid patient       
    else if (response.validationType == ValidationType.InvalidPatient) {
      errorMessage = this.resourceKeyValue.invalidPatientId.replace('{patientId}', searchText)
      this.openValidationModal(errorMessage);
    }
    // Invalid device in case of Patient page  
    else if (response.validationType == ValidationType.InvalidDevice) {
      errorMessage = this.resourceKeyValue.invalidDeviceId.replace('{deviceId}', searchText)
      this.openValidationModal(errorMessage);
    }
    else if (response.validationType == ValidationType.RegexMatchWithMultipleDeviceTypes) {
      this.modalBodyMessage = this.resourceKeyValue.deviceMatchWithMultipleTypes;
      this.openModal(this.validationModel);
    }
  }

  openValidationModal(modalBodyMessage: string) {
    this.modalBodyMessage = modalBodyMessage;
    this.openModal(this.validationModel);
  }

  openCreateDeviceModal(modalBodyMessage: string) {
    this.modalBodyMessage = modalBodyMessage;
    this.openModal(this.deviceCreationModal);
  }

  createDevice() {
    this.closeModal();
    this.isLoading = true;
    this.clinicalService.createClinicianDevice(this.createRequestObject()).subscribe(response => {
      if (response && response.status == ResponseStatus.Success) {
        this.searchAPIResponse = response;
        this.manageDeviceValidations(response);
      } else {
        this.modalBodyMessage = this.resourceKeyValue.deviceErrorMessageOnCreate;
        this.openModal(this.validationModel);
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
      console.error(error);
      this.modalBodyMessage = this.resourceKeyValue.deviceErrorMessageOnCreate;
      this.openModal(this.validationModel);
    });
  }

  createRequestObject(): ICreateDevice {
    let requestObj = {
      id: -1,
      facilityID: Number(localStorage.getItem('facilityId')),
      deviceID: this.searchAPIResponse.searchText.trim(),
      deviceTypeID: this.searchAPIResponse.deviceModel.deviceTypeRecordId,
      deviceModelID: this.searchAPIResponse.deviceModel.deviceModelId,
      deviceAtlasKey: "",
      deviceTypeCode: this.searchAPIResponse.deviceModel.deviceTypeCode,
      type: this.searchAPIResponse.validationType
    };
    return requestObj;
  }

  closeModal(): void {
    this.modalRef.close();
  }

  updateDetailPageHeaderAndPlaceholder() {
    if (localStorage.getItem("SearchPage") == SearchPage.Patient) {
      this.clinicalSearchPlaceholder = this.resourceKeyValue.patientDetailSearchPlaceHolder;
      this.detailPageSearchHeader = this.resourceKeyValue.patientPageSearchHeader;
    }
    else {
      this.clinicalSearchPlaceholder = this.resourceKeyValue.clinicianSearchPlaceHolder;
      this.detailPageSearchHeader = this.resourceKeyValue.devicePageSearchHeader;
    }
  }

  updatePatientId() {
    this.patientDeviceAssociationRequest.forEach(element => {
      element.patientRecordId = this.patientDeviceData.patientRecord.id;
      element.patientId = this.patientDeviceData.patientRecord.patientId;
      element.oldPatientId = this.patientDeviceData.activeDeviceAssociation?.oldPatientId;
      element.oldPatientRecordId = this.patientDeviceData.activeDeviceAssociation?.oldPatientRecordId;
    });
  }

  updateAssociationIdInDeviceCatalog(association: IPatientDeviceAssociation[]) {
    if (this.patientDeviceData.deviceCatalog.length > 0) {
      association.forEach(element => {
        let indexToUpdate = this.patientDeviceData.deviceCatalog.findIndex(x => x.id === element.deviceRecordId);
        this.patientDeviceData.deviceCatalog[indexToUpdate].associationId = element.associationId;
      });
    }
  }

  disassociateConfirmationPopup(id: number, searchPage: SearchPage, deviceIdentifier: string, disassociateMode: string) {
    // set up the modal and temporaray values  
    this.deletedId = id;
    this.searchPage = searchPage;
    this.disassociateMode = disassociateMode;
    this.openDisassociationModal(disassociateMode);
  }

  openDisassociationModal(disassociateMode: string) {
    this.disassociateModalTitle = disassociateMode == "All" ? this.resourceKeyValue.disassociateAllModalTitle : this.resourceKeyValue.disassociateModalTitle;
    this.modalMessage = disassociateMode == "All" ? this.resourceKeyValue.disassociateAllMessage : this.resourceKeyValue.disassociateMessage;;
    this.modalRef = this.modalService.open(this.disassociateModal, { backdrop: 'static', keyboard: false });
  }

  //Diassociate modal Ok button workflow 
  disassociateDevices() {
    this.isLoading = true;
    this.closeModal();
    if (this.disassociateMode == "All") {
      this.removeAllPatientDeviceAssociation(this.createdisassociationAllRequest());
    }
    else {
      // single device disassociation 
      this.patientDeviceData.deviceCatalog.forEach((device, index) => {
        //devices that are not associated with patient yet
        if (this.searchPage == SearchPage.Device && device.id == this.deletedId) {
          this.isLoading = false;
          this.patientDeviceData.deviceCatalog.splice(index, 1);
          let indexToUpdate = this.patientDeviceAssociationRequest.findIndex(x => x.deviceTypeRecordId === device.deviceTypeRecordId);
          this.patientDeviceAssociationRequest.splice(indexToUpdate, 1);
        }
        else if (this.searchPage == SearchPage.Patient && device.associationId == this.deletedId) {
          // devices that are associated with patient 
          this.patientDeviceDisassociation(this.createdisassociationRequest(device));
        }
      });
    }
  }


  createdisassociationRequest(deviceCatalog: DeviceCatalog): DisassociateRequest {
    let disassociationObj = {
      associationId: deviceCatalog.associationId,
      deviceIdentifier: deviceCatalog.deviceIdentifier,
      patientId: this.patientDeviceData.patientRecord.id,
      patientIdentifier: this.patientDeviceData.patientRecord.patientId,
      deviceAtlasKey: deviceCatalog.deviceAtlasKey,
      deviceTypeCode: deviceCatalog.deviceTypeCode,
    };
    return disassociationObj;
  }

  createdisassociationAllRequest(): DisassociateRequest[] {
    let disassociationObjList: DisassociateRequest[] = [];
    this.patientDeviceData.deviceCatalog.map((device) => {
      let disassociationObj = {
        associationId: device.associationId,
        deviceIdentifier: device.deviceIdentifier,
        patientId: this.patientDeviceData.patientRecord.id,
        deviceAtlasKey: device.deviceAtlasKey,
        deviceTypeCode: device.deviceTypeCode,
        patientIdentifier: this.patientDeviceData.patientRecord.patientId,
      };
      disassociationObjList.push(disassociationObj);
    });
    return disassociationObjList;
  }

  patientDeviceDisassociation(request: DisassociateRequest) {
    this.patientDeviceDisassociationSubscription = this.clinicalService.disassociatePatientDeviceAssociation(request).subscribe(response => {
      this.isLoading = false;
      // Update device table data     
      this.updateDevicesAfterDisassociation();
    },
      (error) => {
        this.isLoading = false;
        console.log(error);
      });
  }

  updateDevicesAfterDisassociation() {
    this.patientDeviceData.deviceCatalog.forEach((value, index) => {
      if (this.searchPage == SearchPage.Patient && value.associationId == this.deletedId) {
        // Remove the data from main object and temporaray patientDeviceAssociation       
        this.patientDeviceData.deviceCatalog.splice(index, 1);
        if (this.patientDeviceData.deviceCatalog.length == 0) {
          this.patientDeviceData.deviceCatalog = null;
        }
        let indexToUpdate = this.patientDeviceAssociationRequest.findIndex(x => x.associationId === value.associationId);
        this.patientDeviceAssociationRequest.splice(indexToUpdate, 1);
      }
    });
  }

  removeAllPatientDeviceAssociation(request: DisassociateRequest[]) {
    this.patientDeviceDisassociationSubscription = this.clinicalService.disassociateAllPatientDeviceAssociation(request).subscribe(response => {
      this.isLoading = false;
      // Update device table
      this.patientDeviceData.deviceCatalog = null;
      this.patientDeviceAssociationRequest = [];
    },
      (error) => {
        this.isLoading = false;
        console.log(error);
      });
  }

  openChangeAssociationModal(response: SearchRequest) {
    let message = this.resourceKeyValue.changeAssociationBody.replace('{deviceTypeName}', response.deviceCatalog[0].deviceTypeName);
    this.modalBodyMessage = message.replace('{deviceIdentifier}', response.deviceCatalog[0].deviceIdentifier);
    this.setActiveAssociatioData(response);
    this.openModal(this.changeAssociationModel);
  }

  setActiveAssociatioData(response: SearchRequest) {
    let device = this.searchAPIResponse.deviceCatalog[0];
    device.associationId = this.searchAPIResponse.activeDeviceAssociation?.associationId;
    device.oldPatientId = this.searchAPIResponse.activeDeviceAssociation?.oldPatientId;
    device.oldPatientRecordId = this.searchAPIResponse.activeDeviceAssociation?.oldPatientRecordId;
    this.searchAPIResponse.deviceCatalog[0] = device;
  }

  changeAssociation() {
    this.closeModal();
    if (this.isArcticSunDeviceType(this.searchAPIResponse)) {
      this.patientTherapyForm.reset();
      this.openModal(this.patientTherapyModal);
    }
    else {
      this.isLoading = true;
      this.updateDeviceTable(this.searchAPIResponse);
    }
  }

  showDeviceAlreadyAssociatedModal() {
    this.modalBodyMessage = this.resourceKeyValue.deviceAlreadyAssociated;
    this.openModal(this.validationModel);
  }

  ngOnDestroy(): void {
    if (this.clinicalServiceSubscription && !this.clinicalServiceSubscription.closed) {
      this.clinicalServiceSubscription.unsubscribe();
    }
    if (this.clinicalAssociationSubscription && !this.clinicalAssociationSubscription.closed) {
      this.clinicalAssociationSubscription.unsubscribe();
    }
    if (this.patientDataSubscription && !this.patientDataSubscription.closed) {
      this.patientDataSubscription.unsubscribe();
    }
    if (this.patientDeviceDisassociationSubscription && !this.patientDeviceDisassociationSubscription.closed) {
      this.patientDeviceDisassociationSubscription.unsubscribe();
    }
  }
  showSuccessNotification(message: string) {
    this.toastrService.success(message, this.resource, {
      timeOut: 3000,
      closeButton: true,
      positionClass: 'toast-top-center',
    });
  }
  showErrorNotification(message: string) {
    this.toastrService.error(message, this.resource, {
      timeOut: 3000,
      closeButton: true,
      positionClass: 'toast-top-center',
    });
  }
}
